import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "client/api/_keys";
import { Routes } from "client/api/_routes";
import { onVerifyCodeResponse } from "./helper";

import { authAtom } from "store";
import { useSetRecoilState } from "recoil";

const verifyCode = async (data: VerifyCodeReqT) =>
  axios.post(Routes.VERIFY_CODE, data);

export const useVerifyCode = () => {
  const setAuth = useSetRecoilState(authAtom);

  return useMutation({
    mutationKey: [Keys.VERIFY_CODE_MUT],
    mutationFn: verifyCode,
    onSuccess: (res) => {
      onVerifyCodeResponse(res, setAuth);

      return res;
    },
  });
};
